import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import TrainingDashboardLayout from './TrainingDashboardLayout'

const TrainingDashboardContainer = ({ currentTraining }) => {
  return <>{currentTraining && <TrainingDashboardLayout />}</>
}

TrainingDashboardContainer.propTypes = {
  currentTraining: PropTypes.shape().isRequired,
}
export default connect(
  ({ trainings: { current } }) => ({
    currentTraining: current,
  }),
  {}
)(TrainingDashboardContainer)
